/* eslint-disable */
import { catFetchGet } from './base/catFetchClient';

export type UserWeeklyLog = {
    weeklyLogId: number
    weekYearId: number
    entityId: string
    percentLogged: number
    dateTime: Date
    jobCode: string
    jobDescription: string
    officeLocation: string
    orgLevel2: number
    orgLevel4: number
    hoursLogged: number,
    isDeleted:boolean,
    isHoursEdit:boolean
}

export const getUserWeeklyLog = async (weekId: number) => {
    return await catFetchGet(`weeklylog/getweeklogentries?weekId=${weekId}`);
}